import React, { useEffect, useState } from 'react';
import {
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
  Typography,
} from '@mui/material';
import { DbQuestionData, ReportInaccuracy } from '../components/room/types';
import { Stack } from '@mui/system';

type PropTypes = {
  handleInaccuracyCommentOnChange: (
    questionIndex: number,
    text: string
  ) => void;
  handleReportSubmit: (questionIndex: number) => void;
  openReportInaccuracyModal: boolean;
  questionSet: DbQuestionData[];
  reportedInaccuracies?: ReportInaccuracy[];
  setOpenReportInaccuracyModal: (open: boolean) => void;
};

export const ReportInaccuraciesModal = ({
  handleInaccuracyCommentOnChange,
  handleReportSubmit,
  openReportInaccuracyModal,
  questionSet,
  reportedInaccuracies,
  setOpenReportInaccuracyModal,
}: PropTypes) => {
  const getComment = (questionIndex: number) => {
    if (!reportedInaccuracies) return;
    const report = reportedInaccuracies.find(
      (r) => r.questionIndex === questionIndex
    );
    if (!report?.submitted) return;
    return report?.comment;
  };

  const isReported = (report: ReportInaccuracy) =>
    !!reportedInaccuracies?.find(
      (e) => e.questionIndex === report.questionIndex
    )?.submitted;

  return (
    <Dialog
      open={openReportInaccuracyModal}
      onClose={() => setOpenReportInaccuracyModal(false)}
      scroll={'paper'}
      aria-labelledby="scroll-dialog-title"
      aria-describedby="scroll-dialog-description"
    >
      <DialogTitle id="scroll-dialog-title">Reported Inaccuracies</DialogTitle>
      <DialogContent dividers>
        <DialogContentText
          id="scroll-dialog-description"
          // ref={descriptionElementRef}
          tabIndex={-1}
        >
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            Remember: the game PAR relies just as much on the letter reveal as
            it does on the question. THEREFORE, inaccuracy in this case means
            TYPOS or COUNTERFACTUAL information. NON-SPECIFICITY IS NOT AN
            INACCURACY in PAR. We do our best to pin questions as much as
            possible, but a non-specific question is still a FAIR question in
            PAR.
          </Typography>
          {reportedInaccuracies &&
            reportedInaccuracies
              ?.sort((a, b) => a.questionIndex - b.questionIndex)
              .map((report, index) => (
                <div key={report.questionIndex + 1}>
                  <Typography id="modal-inaccuracy-question" mt={3}>
                    <strong>#{report.questionIndex + 1}</strong>:{' '}
                    {questionSet[report.questionIndex].question}
                  </Typography>
                  <Stack direction={'row'} spacing={2} sx={{ mt: 2 }}>
                    <TextField
                      type="text"
                      placeholder="Explain the inaccuracy"
                      fullWidth
                      variant="outlined"
                      onChange={(e) =>
                        handleInaccuracyCommentOnChange(
                          report.questionIndex,
                          e.target.value
                        )
                      }
                      value={getComment(report.questionIndex)}
                      disabled={isReported(report)}
                    />
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => handleReportSubmit(report.questionIndex)}
                      disabled={isReported(report)}
                    >
                      {isReported(report) ? 'Reported' : 'Report'}
                    </Button>
                  </Stack>
                </div>
              ))}
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
};
